<script>
  import Dropdown from "./Helpers/Dropdown.svelte";
  import { reportCopy, getCopyId } from "../stores/currentSelections.js";

  const searchTitle = getCopyId($reportCopy, "calculator-plan-copy"),
    searchDefault = getCopyId($reportCopy, "calculator-plan-default"),
    scenarioTitle = getCopyId($reportCopy, "calculator-scenario-copy"),
    scenarioDefault = getCopyId($reportCopy, "calculator-scenario-default");
</script>

<div class="w-full mt-8">
  <Dropdown type="search" placeholder={searchDefault} icon="search-Light">
    <h6 class="font-normal text-neutral">
      {searchTitle}
    </h6>
  </Dropdown>

  <Dropdown type="scenarios" bg="gray-100" placeholder={scenarioDefault}>
    <h6 class="font-normal text-neutral">
      {scenarioTitle}
    </h6>
  </Dropdown>
</div>

<style>
  .font-normal {
    font-weight: normal;
  }
</style>
